import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AccessToken } from '@okta/okta-auth-js';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Allows access to the Okta migration page only for non-Okta (legacy) users.
 * Okta users are redirected to /dashboard.
 */
export const OktaMigrationGuard: CanActivateFn = (): Observable<boolean> => {
  const router = inject(Router);
  const oktaAuth = inject(OKTA_AUTH);

  return from(oktaAuth.tokenManager.get('accessToken')).pipe(
    map((token) => {
      const accessToken = token as AccessToken;
      if (accessToken?.accessToken) {
        router.navigate(['/dashboard']);
        return false;
      }
      return true;
    }),
  );
};
